/**
 * PageFeedbackLinkGenerator JS controller.
 *
 * Creates an url with paramenters which can be copied and passed to customers. Parameters are passed
 * to hidden fields in the front end.
 */

const $ = jQuery;

/**
 * Class PageFeedbackLinkGenerator
 */
export default class PageFeedbackLinkGenerator {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
    }

    /**
     * Form actions.
     */
    formActions() {

            let LinkGenerator = $( '#linkgenerator' ),
                enableUrlT    = false,
                enableUrlS    = false,
                urlField      = LinkGenerator.find( '#lomakeurl' ),
                separator     = '&';

            function appendTextToUrl( text, id ) {

                if ( urlField.val().slice( -1 ) === '?' ) {
                    separator = '';
                } else if ( urlField.val().slice( -1 ) === '&' ) {
                    separator = '';
                } else {
                    separator = '&';
                }

                urlField.val( urlField.val() + separator + id + '=' + encodeURIComponent( text ) );

                LinkGenerator.find( '.form .textfield' ).each( function() {

                    if ( $( this ).val().length < 3 ) {

                        enableUrlT = false;
                        return false;

                    } else {

                        enableUrlT = true;

                    }

                });

                LinkGenerator.find( '.form .dropdown' ).each( function() {

                    if ( $( this )[0].selectedIndex === 0 ) {

                        enableUrlS = false;
                        return false;

                    } else {

                        enableUrlS = true;

                    }

                });

                if ( enableUrlT === true && enableUrlS === true ) {

                    urlField.prop( 'disabled', false );

                } else {

                    urlField.prop( 'disabled', true );

                }

            }

            LinkGenerator.find( '.form .textfield' ).keyup( function() {

                let $this     = $( this ),
                    givenText = $this.val(),
                    getId     = $this.attr( 'id' );

                if ( urlField.val().indexOf( getId ) > -1 ) {

                    const pattern = new RegExp( '\\b(' + getId + '=).*?(&|$)' );
                    urlField.val( urlField.val().replace( pattern, '' ) );

                }

                timer( function() {
                    if ( givenText.length > 2 ) {
                        appendTextToUrl( givenText, getId );
                    } else {

                        urlField.prop( 'disabled', true );

                    }
                }, 500 );

            });

            LinkGenerator.find( '.form select' ).change( function() {

                let $this     = $( this ),
                    givenText = $this.val(),
                    getId     = $this.attr( 'id' );

                if ( urlField.val().indexOf( getId ) > -1 ) {

                    const pattern = new RegExp( '\\b(' + getId + '=).*?(&|$)' );
                    urlField.val( urlField.val().replace( pattern, '' ) );

                }

                if ( $( this )[0].selectedIndex !== 0 ) {

                    timer( function() {
                        appendTextToUrl( givenText, getId );
                    }, 500 );

                } else {

                    urlField.prop( 'disabled', true );

                }

            });

            let timer = ( function() {

                let time = 0;

                return function( callback, ms ) {
                    clearTimeout ( time );
                    time = setTimeout( callback, ms );
                };

            }() );

    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.formActions();

    }

}
